import classNames from 'classnames';
import React from 'react';

interface NavGroupProps extends React.PropsWithChildren {
  isDrawerOpen: boolean;
}

export const NavGroup: React.FC<NavGroupProps> = ({ isDrawerOpen, children }) => (
  <nav
    className={classNames('zoom-navgroup-vertical', {
      'zoom-drawer-isOpen': isDrawerOpen,
      'zoom-drawer-isClosed': !isDrawerOpen,
    })}
  >
    <div className="zoom-navgroup-inner">
      <div className="zoom-navbar-group zoom-navbar-group-tier-one">{children}</div>
    </div>
  </nav>
);
